export default __webpack_public_path__ + "static/internal-thread-piercing_1_1-dee55f8e7be0f8ef814ae3c10fba4f64.mp4";